/**
 * Get the member portal URL based on the current environment
 * @returns {string} The member portal URL
 */
export function getMemberURL() {
  // If the local environment is set, return it.
  const localEnv = process.env.VUE_APP_DEV_MEMBER_URL;

  if (localEnv) {
    return localEnv;
  }

  // If the sub-domain is a valid environment include it in the url
  const environments = ['qa', 'new', 'dev'];
  const environment = window.location.host.slice(0, window.location.host.indexOf('.'));

  if (environments.includes(environment)) {
    return `https://${environment}.member.upma.org/`;
  }

  // Else connect with the production url
  return process.env.VUE_APP_MEMBER_URL;
}

/**
 * Proxy into a member account by getting a delegation token and opening the member portal
 * @param {object} axios - Axios instance
 * @param {string} username - Username/email to proxy as
 * @param {string} clientId - OAuth client ID (default: 'adminProxy')
 * @returns {Promise<void>}
 */
export async function proxyAsMember(axios, username, clientId = 'adminProxy') {
  const res = await axios.post('/admin/login', {
    grant_type: 'delegation',
    client_id: clientId,
    target_username: username
  });

  const token = res.data;
  const memberURL = getMemberURL();
  
  window.open(`${memberURL}?token=${token.access_token}`);
}

